import { render, staticRenderFns } from "./InputBuscaUsuarioUO.vue?vue&type=template&id=5a5e7200&scoped=true"
import script from "./InputBuscaUsuarioUO.vue?vue&type=script&lang=ts"
export * from "./InputBuscaUsuarioUO.vue?vue&type=script&lang=ts"
import style0 from "./InputBuscaUsuarioUO.vue?vue&type=style&index=0&id=5a5e7200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e7200",
  null
  
)

export default component.exports